import React from 'react';
import { Player } from 'video-react';

import { NavLink } from 'react-router-dom';
 
const Doublage = () => {
    return (
        <div className="dubbing">
            <div>
                <div className="bio-nav menu">
                    <NavLink to="/radio">
                        <h1>Radio</h1>
                    </NavLink>
                </div>
                <div className="bio-nav menu bis">
                    <NavLink to="/doublage">
                        <h1>Doublage</h1>
                    </NavLink>
                </div>
                <div className="bio-nav menu">
                    <NavLink to="/musique">
                        <h1>Musique</h1>
                    </NavLink>  
                </div>
                <div className="border"></div>
            </div> 
            <div className="intro">
               Après avoir passé des formations de comédien de doublage et de voix-off, voici quelques unes de mes réalisations. Je travaille également avec les studios <span><a rel="noopener noreferrer" href="http://www.sonidovisual.com/" target="_blank">Sonidovisual</a></span>.
            </div>
            <div>
                <h3>Doublage jeux-vidéos</h3>
                <div className="player-video">
                    <Player className="player"
                        poster={require('../img/ratchet-and-clank.webp')}
                        src={require('../img/video/Ratchet and Clank.mp4')}
                    />
                </div>
                <div className="player-video">
                    <Player className="player"
                        poster={require('../img/wow.png')}
                        src={require('../img/video/World of Warcraft.mp4')}
                    />
                </div>
            </div>
            <div>
                <h3>Doublage publicitaire</h3>
                <div className="player-video">
                    <Player className="player"
                        poster={require('../img/logo-decathlon.jpg')}
                        src={require('../img/video/SPOT DECATHLON.mp4')}
                    />
                </div>
                <div className="player-video">
                    <Player className="player"
                        poster={require('../img/torre-pacheco.jpg')}
                        src={require('../img/video/SPOT MELON DE TORRE PACHECO.mp4')}
                    />
                </div>
            </div>
        </div>
    );
}
 
export default Doublage;